import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Zap, X } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/apiClient";

const DISMISS_KEY = "luxdrop_banner_dismissed";

export const LaunchBanner = () => {
  const [promo, setPromo] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === "1");
  const [referred, setReferred] = useState(false);
  const [welcome, setWelcome] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/featured-promo").then((r) => {
      if (r.data.code) setPromo(r.data);
    }).catch(() => {});
    if (localStorage.getItem("luxdrop_ref")) {
      setReferred(true);
      api.get("/referral/welcome").then((r) => { if (r.data.code) setWelcome(r.data); }).catch(() => {});
    }
  }, []);

  if (dismissed) return null;

  // A referred visitor sees the friend-discount message (better deal)
  if (referred && welcome) {
    return (
      <div data-testid="launch-banner" className="relative bg-signal text-white">
        <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-10 py-2.5 text-center">
          <Zap className="hidden h-4 w-4 shrink-0 sm:block" />
          <p className="text-xs font-semibold uppercase tracking-[0.15em]">
            A friend gave you <span className="font-bold">{welcome.value}% off</span> — applied automatically at checkout 🎁
          </p>
        </div>
        <button data-testid="banner-dismiss-btn" onClick={() => { localStorage.setItem(DISMISS_KEY, "1"); setDismissed(true); }}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-white/80 transition-colors hover:text-white" aria-label="Dismiss">
          <X className="h-4 w-4" />
        </button>
      </div>
    );
  }

  if (!promo) return null;

  const label = promo.type === "percent" ? `${promo.value}% OFF` : `$${promo.value} OFF`;

  const apply = () => {
    localStorage.setItem("luxdrop_promo", promo.code);
    toast.success(`Code ${promo.code} saved — it'll be applied at checkout`);
    navigate("/");
    setTimeout(() => document.getElementById("catalog")?.scrollIntoView({ behavior: "smooth" }), 100);
  };

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  return (
    <div data-testid="launch-banner" className="relative bg-signal text-white">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-10 py-2.5 text-center">
        <Zap className="hidden h-4 w-4 shrink-0 sm:block" />
        <p className="text-xs font-semibold uppercase tracking-[0.15em]">
          Launch offer — {label} sitewide with code <span className="font-bold">{promo.code}</span>
        </p>
        <button
          data-testid="banner-apply-btn"
          onClick={apply}
          className="shrink-0 bg-white px-3 py-1 text-[10px] font-bold uppercase tracking-[0.15em] text-signal transition-transform hover:scale-105"
        >
          Apply
        </button>
      </div>
      <button
        data-testid="banner-dismiss-btn"
        onClick={dismiss}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/80 transition-colors hover:text-white"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
